import script from "./EzTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./EzTable.vue?vue&type=script&setup=true&lang=ts"

import "./EzTable.vue?vue&type=style&index=0&id=3d084333&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d084333"]])

export default __exports__